import CrearListado from "../data/CraerListado"

const CP = () => {
    return (
        <CrearListado zona="cp" />
    )
}

export default CP